import styled from '@emotion/styled';

export const CustomText = styled.p`
  font-family: 'Arial',  sans-serif;
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  line-height: 110%;
  padding: 5px 15px;
  margin: 0px 10px 10px 10px;
  color: rgb(91 56 36);
  span {
    font-weight: 600;
  }
`;
